module.exports = __webpack_public_path__ + "fransa mutfak 11.jpg?18d7da711747dcfb1158db17c3916f32";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 11.jpg
// module id = 338
// module chunks = 0